import { gql } from '@apollo/client'

// MEMBER_STATUS

export default gql`
  query memberStatus($id: ID!) {
    member(id: $id) {
      id
      register_status
      organization_live
    }
  }
`
